<template>
  <div class="banner" id="banner">
    <div class="banner-title">
      <p>{{ $t('banner.title.en') }}</p>
      <p>{{ $t('banner.title.zh') }}</p>

      <p>{{ $t('banner.describe.zh') }}</p>
      <p>{{ $t('banner.describe.en') }}</p>
    </div>
    <div class="banner-but">
      <div @click="onclick">
        {{ $t('banner.more') }}
      </div>
      <div @click="onclick">
        {{ $t('banner.join') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onclick() {
      window.scrollTo({ top: 50000 });
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  width: 100%;
  height: 640px;
  background-image: url("@/assets/backpc.gif");
  background-position: center;
  background-size: 100% 640px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;

  .banner-title {
    margin-top: 76px;

    p:nth-child(1),
    p:nth-child(4) {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
    }

    p:nth-child(2) {
      font-size: 42px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 59px;
    }

    p:nth-child(3) {
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 33px;
    }
  }

  .banner-but {
    display: flex;
    align-items: center;
    margin-top: 30px;

    div {
      width: 140px;
      height: 54px;
      background: #ffffff;
      border-radius: 27px;
      text-align: center;
      line-height: 54px;
      font-size: 16px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      color: #ff5200;
      margin-top: 21px;
      cursor: pointer;
    }

    div:nth-child(1) {
      font-size: 16px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      color: #ff5200;
    }

    div:nth-child(2) {
      font-size: 16px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      background: #ff5200;
      font-weight: 400;
      color: #ffffff;
      margin-left: 40px;

    }
  }
}

@media screen and (max-width: 1080px) {
  .banner {
    width: 108rem;
    height: 70rem;
    background-image: url("@/assets/backh5.gif");
    background-position: center;
    background-size: 100% 70rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    .banner-title {
      margin-top: 10rem;

      p:nth-child(1),
      p:nth-child(4) {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        display: none;
      }

      p:nth-child(2) {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 5.3rem;
      }

      p:nth-child(3) {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 5.3rem;
        margin-top: 2rem;
      }
    }

    .banner-but {
      display: flex;
      align-items: center;
      margin-top: 3rem;

      div {
        width: 21.6rem;
        height: 11.1rem;
        background: #ffffff;
        border-radius: 5.6rem;
        text-align: center;
        line-height: 11.1rem;
        font-size: 3.5rem;
        font-family: MiSans, MiSans;
        font-weight: 400;
        color: #ff5200;
        // margin-top: 21px;
        cursor: pointer;
      }

      div:nth-child(1) {
        font-size: 3.5rem;
        font-family: MiSans, MiSans;
        font-weight: 400;
        color: #ff5200;
      }

      div:nth-child(2) {
        font-size: 3.5rem;
        font-family: MiSans, MiSans;
        font-weight: 400;
        background: #ff5200;
        font-weight: 400;
        color: #ffffff;
        margin-left: 6rem;
      }
    }
  }
}
</style>